<template>
  <!--上传文件-->
  <uploader ref="uploader" :options="options" :autoStart="false" :file-status-text="statusText"
    @files-added="onFilesAdded" @file-added="onFileAdded" @file-success="onFileSuccess" @file-progress="onFileProgress"
    @file-error="onFileError" @file-retry="onFileRetry" @file-complete="onFileComplete" @file-removed="onFileRemoved"
    @complete="complete">
    <uploader-btn id="global-uploader-file-btn" ref="uploadFileBtn">选择文件</uploader-btn>
    <uploader-btn id="global-uploader-folder-btn" ref="uploadFolderBtn" :directory="true">选择文件夹</uploader-btn>
    <uploader-btn id="global-uploader-word-btn" ref="uploadWordBtn" :attrs="word">选择Word</uploader-btn>
    <uploader-btn id="global-uploader-excel-btn" ref="uploadExcelBtn" :attrs="excel">选择Excel</uploader-btn>
    <uploader-btn id="global-uploader-ppt-btn" ref="uploadPPTBtn" :attrs="ppt">选择PPT</uploader-btn>
    <uploader-btn id="global-uploader-markdown-btn" ref="uploadMarkDownBtn" :attrs="markdown">选择Markdown</uploader-btn>
    <uploader-btn id="global-uploader-pdf-btn" ref="uploadPdfBtn" :attrs="pdf">选择Pdf</uploader-btn>
    <uploader-btn id="global-uploader-video-btn" ref="uploadVideoBtn" :attrs="video">选择Videos</uploader-btn>
    <uploader-btn id="global-uploader-image-btn" ref="uploadImageBtn" :attrs="image">选择Images</uploader-btn>
    <div class="tasks">
      <div class="tasks-header">
        <div class="title" v-show="uploadingNumbers">
          {{ uploadingNumbers }}个文件正在上传
        </div>
        <div class="title" v-show="!uploadingNumbers && uploadedNumbers">
          成功上传{{ uploadedNumbers }}个文件
        </div>
        <div class="title" v-show="allComplete && uploadingNumbers == 0 && uploadedNumbers == 0">
          上传失败
        </div>
        <div class="operation">
          <a :class="[expand ? '' : 'act']" @click="toggleExpand">
            <i class="ti-angle-down"></i>
          </a>
          <a class="close" @click="close">
            <i class="iconfont icon-close"></i>
          </a>
        </div>
      </div>
      <uploader-list v-show="expand"></uploader-list>
    </div>
  </uploader>
</template>

<script>
/**
 *  全局上传插件
 *  调用方法：Bus.$emit('openUploader', {}) 打开文件选择框，参数为需要传递的额外参数
 *  监听函数：Bus.$on('fileAdded', fn); 文件选择后的回调
 *           Bus.$on('fileSuccess', fn); 文件上传成功的回调
 */
import xml2js from "xml2js";
import throttle from "lodash.throttle";
import { getIcon } from "@/utils/icon";
import { getToken, getStorage } from "@/utils/auth";
import SparkMD5 from "spark-md5";
import Bus from "@/utils/bus";
import {
  getFileUploadUrl,
  fileComplete,
  newFolders,
  fileOrFolderInfo,
} from "@/api/drive/drive";
import { info } from "@/api/common/index";
import { config } from "@/config/index";
const fileList = [];
let uploader2 = null;
export default {
  name: "globalUploader",
  data () {
    return {
      expand: true,
      app_number: null,
      word: {
        accept: ".doc,.docx",
      },
      excel: {
        accept: ".xls,xlsx",
      },
      ppt: {
        accept: ".ppt,.pptx",
      },
      markdown: {
        accept: ".md,.markdown",
      },
      pdf: {
        accept: ".pdf",
      },
      video: {
        accept:
          ".mpeg,.mp4,.avi,.mov,.asf,.wmv,.3gp,.rmvb,.flv,.mkv,.dat,.rm,.swf",
      },
      image: {
        accept:
          ".bmp,.jpg,.jpeg,.png,.tif,.gif,.pcx,.tga,.exif,.fpx,.svg,.psd,.cdr,.pcd,.dxf,.ufo,.eps,.ai,.raw,.webp",
      },
      allComplete: false,
      uploadingNumbers: 0, // 正在上传的文件数
      uploadedNumbers: 0, // 已上传的文件数
      emptyFileNumbers: 0, // 单次上传已过滤的空文件数
      options: {
        allowDuplicateUploads: true, // 允许再次上传
        removeChunkLink: config.api + "/file/swift/batch/delete",
        // target: "//localhost:3000/upload", // 目标上传 URL
        target: [], // 目标上传 URL
        uploadMethod: "post", //默认为post，根据返回参数修改
        chunkSize: 10485760, //分块大小
        fileParameterName: "file0", //上传文件时文件的参数名，默认file
        maxChunkRetries: 10, //最大自动失败重试上传次数
        chunkRetryInterval: 3000, //重试间隔
        testChunks: false, //是否开启服务器分片校验
        simultaneousUploads: 1,
        forceChunkSize: true, //强制所有的块都是小于等于 chunkSize
        permanentErrors: [403],
        // 服务器分片校验函数，秒传及断点续传基础
        // checkChunkUploadedByResponse: function(chunk, message) {
        //   let objMessage = JSON.parse(message);
        //   if (objMessage.skipUpload) {
        //     return true;
        //   }

        //   return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        // },
        parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
          return (
            "剩余" +
            parsedTimeRemaining
              .replace(/\syears?/, "年")
              .replace(/\days?/, "天")
              .replace(/\shours?/, "小时")
              .replace(/\sminutes?/, "分钟")
              .replace(/\sseconds?/, "秒")
          );
        },
        headers: {
          // 在header中添加的验证，请根据实际业务来
          "X-auth-token": getToken(),
        },
      },
      panelShow: false, //选择文件后，展示上传panel
      collapse: false,
      statusText: {
        success: "校验中",
        error: "出错了",
        uploading: "上传中",
        paused: "等待上传",
        waiting: "等待中",
      },
    };
  },
  destroyed () {
    Bus.$off("image");
    Bus.$off("video");
    Bus.$off("ppt");
    Bus.$off("markdown");
    Bus.$off("excel");
    Bus.$off("word");
    Bus.$off("openUploaderFile");
    Bus.$off("openUploaderFolder");
    // 添加关闭浏览器提示
    window.onbeforeunload = null;
  },
  created () {
    this.throttledUpdateList = throttle(this.updateList, 10000, {
      leading: true,
      trailing: true,
    });
    this.initOptsChunkSize();
  },
  mounted () {
    Bus.$on("image", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadImageBtn) {
        $("#global-uploader-image-btn").click();
      }
    });
    Bus.$on("video", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadVideoBtn) {
        $("#global-uploader-video-btn").click();
      }
    });
    Bus.$on("ppt", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadPPTBtn) {
        $("#global-uploader-ppt-btn").click();
      }
    });
    Bus.$on("markdown", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadMarkDownBtn) {
        $("#global-uploader-markdown-btn").click();
      }
    });
    Bus.$on("pdf", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadPdfBtn) {
        $("#global-uploader-pdf-btn").click();
      }
    });
    Bus.$on("excel", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadExcelBtn) {
        $("#global-uploader-excel-btn").click();
      }
    });
    Bus.$on("word", (query) => {
      this.app_number = query;
      this.params = [];
      if (this.$refs.uploadWordBtn) {
        $("#global-uploader-word-btn").click();
      }
    });
    // 批量上传文件
    Bus.$on("openUploaderFile", (query) => {
      this.params = [];
      if (this.$refs.uploadFileBtn) {
        $("#global-uploader-file-btn").click();
      }
    });
    // 上传文件夹
    Bus.$on("openUploaderFolder", (query) => {
      this.params = [];
      if (this.$refs.uploadFolderBtn) {
        $("#global-uploader-folder-btn").click();
      }
    });
    $(".operation .open").click(function () {
      $(".tasks-body").toggle();
      $(this).toggleClass("act");
    });
    // 清除关闭浏览器提示
    window.onbeforeunload = this.beforeunloadHandler;
    uploader2 = this.$refs.uploader.uploader;
    setTimeout(() => {
      uploader2.assignDrop(document.getElementById("dropLayer"));
    }, 2000);
  },
  computed: {
    tab () {
      return this.$store.state.drive.tab;
    },
    number () {
      return this.$store.state.drive.listQuery.number;
    },
    groupNumber () {
      return this.$store.state.drive.groupNumber;
    },
    // Uploader实例
    // uploader() {
    //   return this.$refs.uploader.uploader;
    // },
  },
  methods: {
    toggleExpand () {
      this.expand = !this.expand;
    },
    // 浏览器关闭时进行用户提示
    beforeunloadHandler (e) {
      e = e || window.event;
      if (this.uploadingNumbers === 0) {
        return null;
      }
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "您是否确认离开此页面-该页面数据可能不会被保存";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "您是否确认离开此页面-该页面数据可能不会被保存";
    },
    // 配置系统分片大小
    initOptsChunkSize () {
      info()
        .then((res) => {
          if (res.status_code === 200) {
            uploader2.opts.chunkSize = res.entity.chunk_size;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    close () {
      this.panelShow = false;
      // 触发关闭上传组件
      Bus.$emit("changeGlobalPluginStatus", {
        plugin: "showGlobalUploader",
        status: false,
      });
      uploader2.cancel();
      this.uploadedNumbers = 0;
      this.uploadingNumbers = 0;
      this.emptyFileNumbers = 0;
    },
    getIcon (type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    // 生成文件夹（在上传文件夹时）
    createFolders (files) {
      return new Promise((resolve, reject) => {
        let bigArray = [];
        files.map((file) => {
          let apipath =
            "/" + file.parent.path.substr(0, file.parent.path.length - 1);
          fileList.push({
            path: file.parent.path,
            number: null,
            apipath: apipath,
            used: false,
          }); //添加一个对象
          if (!bigArray.find((item) => item === apipath)) {
            bigArray.push(apipath);
          }
        });
        newFolders({
          group_number: this.groupNumber,
          number: this.number,
          disk_type: "cloud",
          paramslist: bigArray,
        })
          .then((res) => {
            if (res.status_code === 200) {
              res.entity.map(function (item) {
                let fs = fileList.find((it) => item.name === it.apipath); //将number加入对象中
                if (fs) {
                  fs.number = item.number;
                }
              });
              resolve(res);
            } else {
              // files[0].parent.cancel();
              // this.uploadingNumbers = 0;
              // this.panelShow = false;
              // 当前是取消所有的文件夹上传，如果仅需要取消包含敏感词的文件夹，则需要接口支持
              this.close();
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 获取文件，开始执行上传
    onFilesAdded (files) {
      if (files.length > 500) {
        this.$message({
          type: "warning",
          message: "单次上传的文件数不能超过500个",
        });
        // 仅取消当次选中的所有文件
        files.map(function (file) {
          file.cancel();
        });
        return false;
      }
      this.panelShow = true;
      // 触发显示上传组件
      Bus.$emit("changeGlobalPluginStatus", {
        plugin: "showGlobalUploader",
        status: true,
      });
      this.uploadingNumbers = files.length;
      if (files[0].parent && files[0].parent.isRoot === false) {
        this.createFolders(files).then(() => {
          this.getUploadLocation(files);
        });
      } else {
        this.getUploadLocation(files);
      }
    },
    // 获取上传的位置
    getUploadLocation (files) {
      let number = this.app_number ? this.app_number : this.number;
      // 获取当文件夹名称
      if (number == 0) {
        // return false;
        if (this.groupNumber) {
          this.uploadFiles(files, "我的群盘");
        } else {
          this.uploadFiles(files, "我的云盘");
        }
      } else {
        this.fileOrFolderInfo()
          .then((res) => {
            if (res.status_code === 200) {
              this.uploadFiles(files, res.entity.name);
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      }
    },
    uploadFiles (files, father) {
      if (files[0].parent.isRoot === false) {
        uploader2.fileList[uploader2.fileList.length - 1].father = "正在计算文件大小... ";
        uploader2.fileList[uploader2.fileList.length - 1].father_name = father;
      }
      let that = this;
      this.emptyFileNumbers = 0;
      files.map(function (file) {
        if (file.size === 0) {
          that.emptyFileNumbers++;
          if (that.uploadingNumbers > 0) {
            that.uploadingNumbers--;
          }
          file.cancel();
        } else {
          file.father_name = father
          file.father = "正在计算文件大小..."
          if (file.parent.isRoot === false) {
            // 获取该文件夹的number
            let exist_file = fileList.find(
              (item) => item.path === file.parent.path
            );
            that.getFileUploadUrl(file, exist_file.number);
          } else {
            let number = that.app_number ? that.app_number : that.number;
            that.getFileUploadUrl(file, number);
          }
        }
      });
      if (this.emptyFileNumbers) {
        // 如果文件夹下都是空文件就不显示任务
        if (this.emptyFileNumbers === files.length && !this.uploadedNumbers) {
          this.panelShow = false;
          // 触发关闭上传组件
          Bus.$emit("changeGlobalPluginStatus", {
            plugin: "showGlobalUploader",
            status: false,
          });
        }
        that.$message({
          type: "warning",
          message: `已过滤${that.emptyFileNumbers}个空文件`,
        });
      }
    },
    fileOrFolderInfo () {
      return new Promise((resolve, reject) => {
        fileOrFolderInfo({
          number: this.app_number ? this.app_number : this.number,
          type: "folder",
          is_path: true,
          group_number: this.groupNumber,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onFileAdded (file) {
      Bus.$emit("fileAdded");
    },
    // 申请上传地址
    async getFileUploadUrl (file, number) {
      let storage = getStorage();
      // storage = "openstack";
      // 计算整个文件hash
      file.isCalcHash = true
      console.log(new Date().getTime())
      const fingerprint = await this.makeHash(file)
      file.isCalcHash = false
      console.log(new Date().getTime())
      file.father = '上传到 ' + file.father_name
      uploader2.fileList[uploader2.fileList.length - 1].father = '上传到 ' + uploader2.fileList[uploader2.fileList.length - 1].father_name;
      // return false
      getFileUploadUrl({
        storage: storage ? storage : "",
        number: number,
        file_name: file.name,
        byte: file.size,
        disk_type: "cloud",
        group_number: this.groupNumber,
        fingerprint: fingerprint,
      })
        .then((res) => {
          if (res.status_code === 200) {
            file.storage = storage;
            file.target = [];
            file.query = [];
            file.chunkSize = res.entity.upload_chunk_size;
            file.upload_token = res.entity.upload_token;
            let upload_params = res.entity.upload_params;
            if (storage === "moss") {
              upload_params.map(function (param) {
                file.target.push(param[1].value);
                file.query.push({
                  chunkUploadMethod: param[2].value,
                });
              });
            } else {
              upload_params.map(function (param) {
                file.target.push(param[0].value);
                file.query.push({
                  max_file_count: param[1].value,
                  max_file_size: param[2].value,
                  expires: param[3].value,
                  signature: param[4].value,
                  chunkUploadMethod: param[6].value,
                });
              });
            }
            this.computeMD5(file);
          } else if (res.status_code === 201) {
            const rootFile = file.getRoot()
            rootFile.mergeds = rootFile.mergeds ? rootFile.mergeds + 1 : 1;
            this.uploadedNumbers++;
            if (this.uploadingNumbers > 0) {
              this.uploadingNumbers--;
            }
            // console.log(rootFile)
            if (rootFile.isFolder) {
              if (this.uploadingNumbers === 0) {
                // console.log('全部上传完成了')
                $(`.item-speed #unique-id1-${rootFile.id}`).parent().prev().prev().find('p').html(rootFile.father)
                $(`.item-status #unique-id3-${rootFile.id}`).parent().next().css('width', '100%')
                this.onFileComplete(rootFile)

                $(`.item-speed #unique-id1-${rootFile.id}`).text("上传完成");
                $(`.item-status #unique-id2-${rootFile.id}`)
                  .removeClass("icon-status-processing")
                  .addClass("icon-status-succ");
                $(`.item-status #unique-id4-${rootFile.id}`).hide()
                $(`.item-status #unique-id2-${rootFile.id}`).parent().show()
                $(`.item-status #unique-id3-${rootFile.id}`).prev().hide()
                $(`.item-status #unique-id3-${rootFile.id}`).next().next().hide()
                $(`.item-status #unique-id3-${file.id}`).parent().next().css('width', '100%')
              }
              // 确定刷新时间：当最靠近顶层文件夹的文件上传时刷新一次
              let isTop = true;
              if (file.parent && file.parent.isFolder && file.parent.path) {
                isTop = file.parent.path === file.parent.name + "/" ? true : false;
              } else {
                isTop = true;
              }
              if (isTop) {
                this.throttledUpdateList(true);
              }
            } else {
              $(`.item-speed #unique-id1-${file.id}`).parent().prev().prev().find('p').html(rootFile.father)
              $(`.item-speed #unique-id1-${file.id}`).text("上传完成");
              $(`.item-status #unique-id2-${file.id}`)
                .removeClass("icon-status-processing")
                .addClass("icon-status-succ");
              $(`.item-status #unique-id4-${rootFile.id}`).hide()
              $(`.item-status #unique-id2-${file.id}`).parent().show()
              $(`.item-status #unique-id3-${file.id}`).prev().hide()
              $(`.item-status #unique-id3-${file.id}`).next().next().hide()
              $(`.item-status #unique-id3-${file.id}`).parent().next().css('width', '100%')
              // 确定刷新时间：当最靠近顶层文件夹的文件上传时刷新一次
              let isTop = true;
              if (file.parent && file.parent.isFolder && file.parent.path) {
                isTop = file.parent.path === file.parent.name + "/" ? true : false;
              } else {
                isTop = true;
              }
              if (isTop) {
                this.throttledUpdateList(true);
              }
            }



          } else {
            file.cancel();
            if (this.uploadingNumbers > 0) {
              this.uploadingNumbers--;
            }
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    async makeHash (file) {
      // const m1 = new Date().getTime()
      file = file.file;
      // 分片大小
      const length = 64 * 1024 * 1024;
      let start = 0;
      let end = length;
      let data = '';
      // 1、计算分片数量
      const len = Math.ceil(file.size / length);
      // 2、分割文件核心部分slice
      if (len > 1) {
        // const m1 = new Date().getTime()
        for (let index = 0; index < len; index++) {
          let blob = file.slice(start, end);
          const buffer = await blob.arrayBuffer()
          const md52 = SparkMD5.ArrayBuffer.hash(buffer)
          // const md52 = await this.fileReader_3(blob).then(res => {
          //   return res
          // })

          // const md52 = SparkMD5.hashBinary(blob)
          data += md52
          // 设置start、end
          start += length;
          end += length;
        }
        // const m2 = new Date().getTime()
        data = this.hex2bin(data)
        const md53 = SparkMD5.hashBinary(data)
        // const m3 = new Date().getTime()
        // console.log('m2-m1', m2, m1, m2 - m1)
        // console.log('m3-m2', m3, m2, m3 - m2)
        // console.log(md53 + '-' + len)
        return md53 + '-' + len
      } else {
        const md52 = await this.fileReader_1(file).then(res => {
          return res
        })
        return md52;
      }
    },
    hex2bin (hexx) {
      var hex = hexx.toString();//force conversion
      var str = '';
      for (var i = 0; i < hex.length; i += 2)
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
      return str;
    },
    async fileReader (blob) {
      return new Promise(function (resolve, reject) {
        blob.arrayBuffer().then(buffer => {
          resolve(SparkMD5.ArrayBuffer.hash(buffer))
        })
      })
    },
    fileReader_2 (blob) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        reader.readAsBinaryString(blob)
        reader.onload = function () {
          resolve(SparkMD5.hashBinary(this.result))
        }
      })
    },
    fileReader_1 (blob) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(blob)
        reader.onload = function () {
          resolve(SparkMD5.ArrayBuffer.hash(this.result))
        }
      })
    },
    onFileProgress () { },
    onFileRemoved (file) {
      if (file.size > 0 && this.uploadingNumbers > 0) {
        this.uploadingNumbers--;
      }
    },
    onFileComplete (rootFile) {
      // console.log(rootFile)
      // this.updateList(true);
      // 文件夹上传完成后更改后面上传的文字
      if (rootFile.isFolder) {
        if (rootFile.files.length > rootFile.mergeds) {
          $(`.item-speed #unique-id1-${rootFile.id}`).text(
            "上传完成" + rootFile.mergeds + "个"
          );
          $(`.item-status #unique-id2-${rootFile.id}`)
            .removeClass("icon-status-processing")
            .addClass("icon-status-succ");
          $(`.item-status #unique-id4-${rootFile.id}`).hide()
        }
      }
    },
    complete () {
      // 强制更新将正在上传的文件数量
      this.allComplete = true;
      // this.uploadingNumbers = 0;
    },
    // 更新列表
    updateList (status) {
      Bus.$emit("fileSuccess", status);
    },
    onFileSuccess (rootFile, file, response, chunk) {
      // console.log(rootFile)
      fileComplete({
        upload_token: file.upload_token,
      })
        .then((res) => {
          if (res.status_code === 200) {
            // 更改上传的文字
            rootFile.mergeds = rootFile.mergeds ? rootFile.mergeds + 1 : 1;
            if (rootFile.isFolder) {
              if (rootFile.files.length === rootFile.mergeds) {
                $(`.item-speed #unique-id1-${rootFile.id}`).text("上传完成");
                $(`.item-status #unique-id2-${rootFile.id}`)
                  .removeClass("icon-status-processing")
                  .addClass("icon-status-succ");

                $(`.item-status #unique-id4-${rootFile.id}`).hide()
              }
            } else {
              $(`.item-speed #unique-id1-${rootFile.id}`).text("上传完成");
              $(`.item-status #unique-id2-${rootFile.id}`)
                .removeClass("icon-status-processing")
                .addClass("icon-status-succ");

              $(`.item-status #unique-id4-${rootFile.id}`).hide()
            }
            this.uploadedNumbers++;
            if (this.uploadingNumbers > 0) {
              this.uploadingNumbers--;
            }
            // 确定刷新时间：当最靠近顶层文件夹的文件上传时刷新一次
            let isTop = true;
            if (file.parent && file.parent.isFolder && file.parent.path) {
              isTop =
                file.parent.path === file.parent.name + "/" ? true : false;
            } else {
              isTop = true;
            }
            if (isTop) {
              this.throttledUpdateList(true);
            }
            if (rootFile.isFolder) {
              if (this.uploadingNumbers === 0) {
                // console.log('全部上传完成了11')
                $(`.item-speed #unique-id1-${rootFile.id}`).parent().prev().prev().find('p').html(rootFile.father)
                $(`.item-status #unique-id3-${rootFile.id}`).parent().next().css('width', '100%')
                this.onFileComplete(rootFile)
              }
              $(`.item-speed #unique-id1-${rootFile.id}`).text("上传完成");
              $(`.item-status #unique-id2-${rootFile.id}`)
                .removeClass("icon-status-processing")
                .addClass("icon-status-succ");

              $(`.item-status #unique-id4-${rootFile.id}`).hide()
              $(`.item-status #unique-id2-${rootFile.id}`).parent().show()
              $(`.item-status #unique-id3-${rootFile.id}`).prev().hide()
              $(`.item-status #unique-id3-${rootFile.id}`).next().next().hide()
              // 确定刷新时间：当最靠近顶层文件夹的文件上传时刷新一次
              let isTop = true;
              if (file.parent && file.parent.isFolder && file.parent.path) {
                isTop = file.parent.path === file.parent.name + "/" ? true : false;
              } else {
                isTop = true;
              }
              if (isTop) {
                this.throttledUpdateList(true);
              }
            }
          } else {
            $(`.item-speed #unique-id1-${rootFile.id}`).text("上传失败");
            $(`.item-status #unique-id2-${rootFile.id}`)
              .removeClass("icon-status-processing")
              .addClass("icon-status-fail");
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    onFileError (rootFile, file, message, chunk) {
      const parser = new xml2js.Parser();
      parser.parseString(message, function (err, result) {
        let msg = "";
        if ("AccessDenied" === result.Error.Code[0]) {
          msg = "上传地址已失效，请删除当前任务后重新上传";
          $(`.item-status #unique-id3-${rootFile.id}`).remove();
        } else {
          msg = result.Error.Code[0];
        }
        $(`.item-speed #unique-id1-${rootFile.id}`).parent().parent().attr({
          title: msg,
        });
      });
      // $(".item-speed");
      // if (this.uploadingNumbers > 0) {
      //   this.uploadingNumbers--;
      // }
    },
    onFileRetry (rootFile, file, chunk) {
      // this.uploadingNumbers++;
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5 (file) {
      // let fileReader = new FileReader();
      // let time = new Date().getTime();
      // let md5 = "";
      // file.pause();
      // fileReader.readAsArrayBuffer(file.file);
      // fileReader.onload = e => {
      //   if (file.size != e.target.result.byteLength) {
      //     this.error(
      //       "Browser reported success but could not read the file until the end."
      //     );
      //     return;
      //   }
      // md5 = SparkMD5.ArrayBuffer.hash(e.target.result);
      // // 添加额外的参数
      // // uploader2.opts.query = this.params;
      // console.log(
      //   `MD5计算完毕：${file.id} ${
      //     file.name
      //   } MD5：${md5} 用时：${new Date().getTime() - time} ms`
      // );
      // file.uniqueIdentifier = md5;
      // console.log(file.name);
      // if (file.name === "1.mp3") {
      file.resume();
      // }
      // };
      // fileReader.onerror = function() {
      //   this.error(
      //     "FileReader onerror was triggered, maybe the browser aborted due to high memory usage."
      //   );
      // };
    },
  },
};
</script>
<style scope>
/* .uploader-file {
  position: relative;
  height: 80px;
  line-height: 80px;
  overflow: hidden;
  border-bottom: 1px solid #cdcdcd;
} */
.close {
  opacity: 0.5;
}

.close:hover,
.close:focus {
  opacity: 1;
}

a {
  color: #383838;
  text-decoration: none;
}

a:hover,
a:focus {
  text-decoration: none;
  color: #006adf;
  outline: none;
}

@media (min-width: 768px) {
  .tasks {
    width: 500px;
    margin-top: 10px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 10px;
  }
}

@media (max-width: 768px) {
  .tasks {
    width: calc(100% - 20px);
    margin-top: 10px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 10px;
  }
}

.tasks-header {
  width: 100%;
  height: 50px;
  padding: 10px 20px;
  background: #fff;
  background: #f1f1f1;
  line-height: 30px;
}

.tasks-header .title {
  font-size: 18px;
  float: left;
}

.tasks-header .operation {
  float: right;
}

.tasks-header .operation i {
  width: 30px;
  height: 30px;
  display: block;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
}

.tasks-header .operation a {
  width: 30px;
  height: 30px;
  display: block;
  margin-left: 10px;
  float: left;
}

.tasks-header .operation a:hover {
  background: #eee;
}

.tasks-header .operation .act i {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.tasks-body {
  width: 100%;
  background: #fff;
}

.tasks-item {
  width: 100%;
  height: 60px;
  padding: 15px 20px;
  border-bottom: #eee solid 1px;
  position: relative;
  background: #fff;
}

.tasks-item .progress {
  height: 59px;
  position: absolute;
  bottom: -20px;
  background-color: rgba(0, 106, 223, 0.2);
  box-shadow: none;
  left: 0;
  border-radius: 0;
}

.tasks-item:last-child {
  border-bottom: none;
}

.tasks-item .item-icon {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 20px;
}

.tasks-item .item-icon .icon {
  width: 30px;
  height: 30px;
}

.tasks-item .item-info {
  padding-left: 40px;
  font-size: 12px;
  width: 270px;
  float: left;
}

.tasks-item .item-info h6,
.tasks-item .item-info p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.tasks-item .item-info p {
  color: #999;
  margin-top: 5px;
}

.tasks-item .item-info h6 {
  height: 17px;
}

.tasks-item .item-status {
  width: 50px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  position: absolute;
  right: 20px;
  top: 15px;
  text-align: right;
}

.tasks-item .item-status a {
  width: 25px;
  height: 30px;
  display: inline-block;
  margin: 0 -1.5px;
}

.tasks-item .item-status .start {
  color: #00c15c;
}

.tasks-item .item-status .delete {
  color: #aaa;
}

.tasks-item .item-bit,
.tasks-item .item-speed {
  width: 90px;
  float: left;
  font-size: 12px;
  line-height: 30px;
  text-align: center;
}

.tasks-item .item-status .start.act {
  color: #006adf;
}

.tasks-item .item-status .start.act .icon-status-start:before {
  content: "\e743";
}

.tasks-item .item-status .delete:hover {
  color: #f00;
}

/* 隐藏上传按钮 */
#global-uploader-word-btn,
#global-uploader-excel-btn,
#global-uploader-ppt-btn,
#global-uploader-image-btn,
#global-uploader-video-btn,
#global-uploader-pdf-btn,
#global-uploader-markdown-btn,
#global-uploader-file-btn,
#global-uploader-folder-btn {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>